import { Box } from '@mui/joy';

/**
 * Спокойный премиальный фон экранов авторизации: мягкая «аурора» из
 * размытых цветовых пятен, лёгкий вращающийся блик для глубины, тонкое
 * «зерно» и виньетка для фокуса на карточке. Клики не перехватывает.
 * Движение отключается при prefers-reduced-motion.
 */
const GRAIN =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='140' height='140'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='2'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.5'/%3E%3C/svg%3E\")";

export default function AuthScene() {
  return (
    <Box
      aria-hidden
      sx={{
        position: 'absolute',
        inset: 0,
        overflow: 'hidden',
        pointerEvents: 'none',
        background:
          'radial-gradient(1100px 700px at 12% -5%, #EFE9FB 0%, rgba(239,233,251,0) 60%),' +
          'radial-gradient(1000px 640px at 100% 8%, #E4F0FB 0%, rgba(228,240,251,0) 58%),' +
          'linear-gradient(180deg, #F7F7FD 0%, #EDEBF7 100%)',
        '@keyframes drift1': {
          '0%,100%': { transform: 'translate3d(0,0,0) scale(1)' },
          '50%':     { transform: 'translate3d(34px,-26px,0) scale(1.14)' },
        },
        '@keyframes drift2': {
          '0%,100%': { transform: 'translate3d(0,0,0) scale(1.05)' },
          '50%':     { transform: 'translate3d(-30px,22px,0) scale(0.92)' },
        },
        '@keyframes drift3': {
          '0%,100%': { transform: 'translate3d(0,0,0) scale(1)' },
          '50%':     { transform: 'translate3d(22px,26px,0) scale(1.1)' },
        },
        '@keyframes sheen': {
          '0%':   { transform: 'rotate(0deg)' },
          '100%': { transform: 'rotate(360deg)' },
        },
        '& .orb': {
          position: 'absolute',
          borderRadius: '50%',
          filter: 'blur(72px)',
          willChange: 'transform',
        },
        '@media (prefers-reduced-motion: reduce)': {
          '& .orb, & .sheen': { animation: 'none !important' },
        },
      }}
    >
      <Box className="orb" sx={{
        width: 420, height: 420, top: '-120px', left: '-100px',
        background: 'radial-gradient(circle at 30% 30%, #8F87F0 0%, rgba(143,135,240,0) 70%)',
        opacity: 0.55, animation: 'drift1 20s ease-in-out infinite',
      }} />
      <Box className="orb" sx={{
        width: 380, height: 380, top: '-60px', right: '-120px',
        background: 'radial-gradient(circle at 50% 50%, #8FB8F5 0%, rgba(143,184,245,0) 70%)',
        opacity: 0.5, animation: 'drift2 26s ease-in-out infinite',
      }} />
      <Box className="orb" sx={{
        width: 460, height: 460, bottom: '-160px', left: '20%',
        background: 'radial-gradient(circle at 50% 50%, #93E3D4 0%, rgba(147,227,212,0) 70%)',
        opacity: 0.4, animation: 'drift3 30s ease-in-out infinite',
      }} />
      <Box className="orb" sx={{
        width: 360, height: 360, bottom: '-140px', right: '-80px',
        background: 'radial-gradient(circle at 50% 50%, #F1B8DB 0%, rgba(241,184,219,0) 70%)',
        opacity: 0.32, animation: 'drift1 24s ease-in-out infinite',
      }} />

      <Box className="sheen" sx={{
        position: 'absolute', inset: '-40%',
        background:
          'conic-gradient(from 0deg at 50% 50%, rgba(255,255,255,0) 0deg, rgba(255,255,255,0.35) 60deg, rgba(255,255,255,0) 140deg, rgba(255,255,255,0) 360deg)',
        mixBlendMode: 'soft-light',
        animation: 'sheen 40s linear infinite',
      }} />

      <Box sx={{
        position: 'absolute', inset: 0,
        backgroundImage: GRAIN, backgroundSize: '140px 140px',
        opacity: 0.04, mixBlendMode: 'multiply',
      }} />

      <Box sx={{
        position: 'absolute', inset: 0,
        background: 'radial-gradient(120% 90% at 50% 45%, rgba(0,0,0,0) 55%, rgba(46,43,99,0.10) 100%)',
      }} />
    </Box>
  );
}